module.exports = __webpack_public_path__ + "img/_chat_bubble_small.00f2b9c1.svg";